<template lang="pug">
div#app
  RegistrationUrlTracker
  MyGamesHeaderWrapper
  index(:isMyGames="isMyGames")
</template>

<script>
import env from "@godweb/frontend-base/src/libs/tools/Environment";
import MyGamesHeaderWrapper from "@static_promo_pages/common/components/mygamesheader/vue/MyGamesHeaderWrapper";
import RegistrationUrlTracker from "@godweb/frontend-base/src/components/registrationurltracker/RegistrationUrlTracker.vue";
import index from "./components/index";

export default {
  name: "App",
  components: {
    MyGamesHeaderWrapper,
    RegistrationUrlTracker,
    index,
  },
  computed: {
    isMyGames() {
      return env.isMyGames();
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/style/index.scss";
</style>
